import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed, inject, ref } from 'vue'
import type { PPTChartElement } from '@/types/slides'
import { injectKeySlideScale } from '@/types/injectKey'

import ElementOutline from '@/views/components/element/ElementOutline.vue'
import Chart from './Chart.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseChartElement',
  props: {
    elementInfo: {}
  },
  setup(__props: any) {



const slideScale = inject(injectKeySlideScale) || ref(1)

const needScaleSize = computed(() => slideScale.value < 1)
const zoom = computed(() => needScaleSize.value ? 1 / slideScale.value : 1)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-chart",
    style: _normalizeStyle({
      top: _ctx.elementInfo.top + 'px',
      left: _ctx.elementInfo.left + 'px',
      width: _ctx.elementInfo.width + 'px',
      height: _ctx.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${_ctx.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", {
        class: "element-content",
        style: _normalizeStyle({
          backgroundColor: _ctx.elementInfo.fill,
        })
      }, [
        _createVNode(ElementOutline, {
          width: _ctx.elementInfo.width,
          height: _ctx.elementInfo.height,
          outline: _ctx.elementInfo.outline
        }, null, 8, ["width", "height", "outline"]),
        _createVNode(Chart, {
          width: _ctx.elementInfo.width * zoom.value,
          height: _ctx.elementInfo.height * zoom.value,
          type: _ctx.elementInfo.chartType,
          data: _ctx.elementInfo.data,
          options: _ctx.elementInfo.options,
          themeColor: _ctx.elementInfo.themeColor,
          gridColor: _ctx.elementInfo.gridColor,
          legends: _ctx.elementInfo.data.legends,
          legend: _ctx.elementInfo.legend || '',
          style: _normalizeStyle({ zoom: 1 / zoom.value })
        }, null, 8, ["width", "height", "type", "data", "options", "themeColor", "gridColor", "legends", "legend", "style"])
      ], 4)
    ], 4)
  ], 4))
}
}

})